var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container",staticStyle:{"margin-bottom":"18vh"}},[_c('contact-options',{ref:"contact",attrs:{"visibility":_vm.onViewport,"id":"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }